<iframe [src]="url" frameborder="0" allowfullscreen="true"></iframe>
